import type { ReactNode } from 'react';
import { AppLogo } from '@/components/common/AppLogo';
import { AppWordmark } from '@/components/common/AppWordmark';
import { COMPANY_ADDRESS, COMPANY_NAME } from '@/constants/app.constants';

export interface PrintReportDetail {
  label: string;
  value: string | undefined;
}

interface PrintReportProps {
  title: string;
  details: PrintReportDetail[];
  children: ReactNode;
}

export function PrintReport({ title, details, children }: PrintReportProps) {
  return (
    <section className="hidden flex-col gap-3 text-foreground print:flex">
      <div className="grid grid-cols-[1fr_auto_1fr] items-center gap-4">
        <div className="flex items-center gap-2">
          <AppLogo className="size-9" />
          <AppWordmark className="h-5.5" />
        </div>
        <div className="text-center">
          <p className="text-lg font-bold">{COMPANY_NAME}</p>
          <p className="text-xs">{COMPANY_ADDRESS}</p>
        </div>
      </div>

      <h2 className="border-b border-foreground pb-1 text-center text-base font-bold">{title}</h2>

      <dl className="grid grid-cols-2 gap-x-12 gap-y-0.5 px-10 text-xs">
        {details.map((detail) => (
          <div key={detail.label} className="grid grid-cols-[6rem_1fr]">
            <dt>{detail.label}</dt>
            <dd>: {detail.value ?? ''}</dd>
          </div>
        ))}
      </dl>

      {children}
    </section>
  );
}
